__webpack_require__.p = "/wp-content/themes/assembling/assets/";